import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HttpClientModule } from '@angular/common/http';
import { FormsModule } from '@angular/forms';

import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

import { AppComponent } from './app.component';
import { HomeComponent } from './home/home.component';
import { ArtComponent } from './art/art.component';
import { ProjectComponent } from './art/project.component';
import { ProjectResolver } from './art/project-resolver.service';
import { WorkComponent } from './work/work.component';
import { AssetPipe, FooterComponent, HeaderComponent } from './shared';
import { AppRoutes } from './app.routing';

@NgModule({
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    FormsModule,
    NgbModule.forRoot(),
    AppRoutes
  ],
  declarations: [
    AppComponent,
    AssetPipe,
    FooterComponent,
    HeaderComponent,
    HomeComponent,
    ArtComponent,
    ProjectComponent,
    WorkComponent
  ],
  providers: [
    ProjectResolver
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/app.module.ts